// extracted by mini-css-extract-plugin
export var highlightFade = "_39-4";
export var highlighted = "_39-3";
export var table = "_39-1";
export var tableContainer = "_39-0";
export var totalsRow = "_39-2";